import React, { Component } from "react";
import { connect } from "react-redux";

class Logout extends Component {
  logout() {
    const keycloak = this.props.posts.map((post) => post.keycloak);
    const realm = this.props.posts.map((post) => post.realm);
    const id_token = this.props.posts.map((post) => post.id_token);

    try {
      //for Keycloak 17.0.1 or older version
      keycloak.logout();
    } catch (error) {
      //for Keycloak newer version 18.0.0 or later
      window.location =
        process.env.REACT_APP_KEYCLOAK_URL +
        "/realms/" +
        realm +
        "/protocol/openid-connect/logout?" +
        "post_logout_redirect_uri=" +
        window.location.origin +
        "&id_token_hint=" +
        id_token;
    }
  }
  render() {
    return (
      <>
        <button
        style={{
            backgroundColor: "#E5E5EA",
            padding: "10px 15px 10px 15px",
            marginLeft: "15px",
            borderRadius: "100px",
            marginRight: "4px",
            border: "none"
            
          }}
          onClick={() => this.logout()}
        >
          {/* <i className="bi bi-box-arrow-right"></i> */}
          <img alt="Logout" src="images/Icon-down.png" />
        </button>
        
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { posts: state.posts };
};

export default connect(mapStateToProps)(Logout);
